
import React, { useEffect, useState } from "react";
import img1 from "../../assets/homeimg1.jpg";
import img2 from "../../assets/homeimg2.png";
import img3 from "../../assets/homeimg3.jpg";
import slider1 from "../../assets/slider1.jpg";
import slider2 from "../../assets/slider2.jpg";
import water_glace from "../../assets/water_glace.svg";
import {
  FaPhoneAlt,
  FaStar,
  FaLeaf,
  FaTruck,
  FaUsers,
  FaHandsHelping,
  FaChartLine,
  FaWater,
  FaShieldAlt,
  FaCheckCircle,
  FaTint,
  FaHeartbeat,
} from "react-icons/fa";

const images = [slider1, slider2, img1, img2, img3];

export default function Home() {
  const [counters, setCounters] = useState({
    customers: 0,
    deliveries: 0,
    partners: 0,
    satisfaction: 0,
  });

  useEffect(() => {
    const target = {
      customers: 1200,
      deliveries: 18500,
      partners: 45,
      satisfaction: 98,
    };
    const speed = 30;

    const interval = setInterval(() => {
      setCounters((prev) => {
        const updated = { ...prev };
        let done = true;

        for (const key in prev) {
          if (prev[key] < target[key]) {
            updated[key] = Math.min(
              prev[key] + Math.ceil(target[key] / 50),
              target[key]
            );
            done = false;
          }
        }

        if (done) clearInterval(interval);
        return updated;
      });
    }, speed);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <style>{`
  .scroll-slider {
    width: 100%;
    height: 50vh;
    overflow: hidden;
    position: relative;
  }
  .scroll-track {
    display: flex;
    animation: slideMove 18s linear infinite;
  }
  .scroll-img {
    width: 50vw;
    height: 50vh;
    flex-shrink: 0;
  }
  .scroll-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @keyframes slideMove {
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  }
  @media (max-width: 768px) {
    .scroll-slider { height: 35vh; }
    .scroll-img { width: 100vw; height: 35vh; }
    @keyframes slideMove {
      0% { transform: translateX(0); }
      100% { transform: translateX(-100%); }
    }
  }
`}</style>

      {/* 🔹 Smooth Auto Slider */}
      <div className="scroll-slider">
        <div className="scroll-track">
          {images.map((img, i) => (
            <div className="scroll-img" key={i}>
              <img src={img} alt="slide" />
            </div>
          ))}
          {images.map((img, i) => (
            <div className="scroll-img" key={i + "-dup"}>
              <img src={img} alt="slide-dup" />
            </div>
          ))}
        </div>
      </div>

      {/* 🔹 Intro */}
      <section style={{ padding: "60px 20px", textAlign: "center", background: "#f9fdfd" }}>
        <h2 style={{ color: "#022c32", marginBottom: 20, fontSize: "2rem" }}>
          Welcome to <span style={{ color: "#03b8b3" }}>Chilled Water CRM</span>
        </h2>
        <p
          style={{
            maxWidth: 800,
            margin: "0 auto",
            fontSize: "1rem",
            lineHeight: 1.6,
            color: "#555",
          }}
        >
          Manage your water business smarter and faster. Everything from orders to delivery &
          payments — all in one CRM.
        </p>
      </section>

      {/* 🔹 Stats */}
      <section
        style={{
          background: "linear-gradient(120deg, #03b8b3, #04d4cd)",
          color: "#fff",
          padding: "50px 20px",
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
          textAlign: "center",
          gap: "20px",
        }}
      >
        {[
          { label: "Happy Customers", count: counters.customers, icon: <FaUsers size={40} /> },
          { label: "Deliveries Done", count: counters.deliveries, icon: <FaTruck size={40} /> },
          { label: "Active Partners", count: counters.partners, icon: <FaHandsHelping size={40} /> },
          { label: "Satisfaction Rate", count: `${counters.satisfaction}%`, icon: <FaStar size={40} /> },
        ].map((stat, i) => (
          <div key={i}>
            <div style={{ marginBottom: 8 }}>{stat.icon}</div>
            <h2 style={{ margin: 0, fontSize: "2rem" }}>{stat.count}</h2>
            <p>{stat.label}</p>
          </div>
        ))}
      </section>

      {/* 🔹 Why Choose Us */}
      <section style={{ padding: "60px 20px", textAlign: "center", background: "#fff" }}>
        <h2 style={{ color: "#022c32", marginBottom: 30 }}>Why Choose Us?</h2>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "25px",
            maxWidth: 1000,
            margin: "0 auto",
          }}
        >
          {[
            { icon: <FaWater size={40} color="#03b8b3" />, title: "Smart Water Tracking", desc: "Track jars & capsules daily." },
            { icon: <FaChartLine size={40} color="#03b8b3" />, title: "Analytics", desc: "Monthly reports & insights." },
            { icon: <FaLeaf size={40} color="#03b8b3" />, title: "Eco Friendly", desc: "Reusable jars & green delivery." },
          ].map((f, i) => (
            <div
              key={i}
              style={{
                background: "#f9fdfd",
                padding: 20,
                borderRadius: 10,
                border: "1px solid #e5f5f5",
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
              }}
            >
              {f.icon}
              <h4 style={{ marginTop: 12 }}>{f.title}</h4>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* 🔹 RO Water Benefits - Modern Premium UI */}
<section
  style={{
    padding: "70px 20px",
    background: "linear-gradient(135deg, #f9fdfd, #e8ffff)",
    textAlign: "center",
  }}
>
  <h2
    style={{
      color: "#022c32",
      fontSize: "2rem",
      marginBottom: 10,
      fontWeight: "700",
    }}
  >
    Benefits of RO Purified Water
  </h2>

  <p
    style={{
      color: "#444",
      maxWidth: 750,
      margin: "0 auto 50px",
      fontSize: "1rem",
      lineHeight: 1.6,
    }}
  >
    RO technology ensures your family drinks only the purest and safest water by
    removing harmful contaminants while maintaining essential minerals.
  </p>

  <style>{`
    .benefit-card {
      background: rgba(255, 255, 255, 0.7);
      backdrop-filter: blur(10px);
      padding: 20px;
      border-radius: 14px;
      border: 1px solid rgba(255,255,255,0.5);
      box-shadow: 0 4px 18px rgba(0,0,0,0.08);
      display: flex;
      align-items: flex-start;
      gap: 15px;
      transition: transform 0.3s ease, box-shadow 0.3s ease;
    }
    .benefit-card:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 25px rgba(0,0,0,0.15);
    }
    .center-glass {
      animation: float 4s ease-in-out infinite;
    }
    @keyframes float {
      0% { transform: translateY(0px); }
      50% { transform: translateY(-12px); }
      100% { transform: translateY(0px); }
    }
  `}</style>

  {/* LAYOUT WRAPPER */}
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
      gap: "40px",
      flexWrap: "wrap",
      maxWidth: 1200,
      margin: "0 auto",
    }}
  >
    {/* LEFT BENEFITS */}
    <div
      style={{
        flex: "1 1 300px",
        display: "flex",
        flexDirection: "column",
        gap: 25,
      }}
    >
      {[
        {
          icon: <FaShieldAlt size={40} color="#03b8b3" />,
          title: "Removes 99% Impurities",
          desc: "Filters bacteria, viruses, heavy metals & harmful chemicals.",
        },
        {
          icon: <FaTint size={40} color="#03b8b3" />,
          title: "Better Taste & Freshness",
          desc: "Eliminates chlorine, bad odor and improves overall taste.",
        },
        {
          icon: <FaHeartbeat size={40} color="#03b8b3" />,
          title: "Healthy & Safe",
          desc: "Reduces risk of water-borne diseases and improves hydration.",
        },
      ].map((b, i) => (
        <div key={i} className="benefit-card">
          {b.icon}
          <div>
            <h4 style={{ margin: 0, color: "#022c32" }}>{b.title}</h4>
            <p style={{ margin: 0, color: "#555" }}>{b.desc}</p>
          </div>
        </div>
      ))}
    </div>

    {/* CENTER FLOATING GLASS IMAGE */}
    <div
      style={{
        flex: "1 1 250px",
        maxWidth: 280,
        display: "flex",
        justifyContent: "center",
      }}
    >
      <img
        className="center-glass"
        src={water_glace}
        alt="Glass of Water"
        style={{
          width: "80%",
          maxWidth: 250,
          filter: "drop-shadow(0 10px 20px rgba(0,0,0,0.15))",
        }}
      />
    </div>

    {/* RIGHT BENEFITS */}
    <div
      style={{
        flex: "1 1 300px",
        display: "flex",
        flexDirection: "column",
        gap: 25,
      }}
    >
      {[
        {
          icon: <FaCheckCircle size={40} color="#03b8b3" />,
          title: "Safe for Children",
          desc: "Pure water ideal for infants, kids & elderly family members.",
        },
        {
          icon: <FaLeaf size={40} color="#03b8b3" />,
          title: "Maintains Minerals",
          desc: "Ensures a healthy balance of essential minerals.",
        },
        {
          icon: <FaWater size={40} color="#03b8b3" />,
          title: "Crystal Clear Water",
          desc: "Transparent, fresh and perfect for cooking & drinking.",
        },
      ].map((b, i) => (
        <div key={i} className="benefit-card">
          {b.icon}
          <div>
            <h4 style={{ margin: 0, color: "#022c32" }}>{b.title}</h4>
            <p style={{ margin: 0, color: "#555" }}>{b.desc}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>


      {/* 🔹 Testimonials */}
      <section
        style={{
          background: "linear-gradient(120deg, #03b8b3, #04d4cd)",
          color: "#fff",
          textAlign: "center",
          padding: "60px 20px",
        }}
      >
        <h2 style={{ fontSize: "1.8rem", marginBottom: 20 }}>What Our Clients Say</h2>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: "25px",
          }}
        >
          {[
            { name: "Rajesh Kumar", msg: "“The best CRM for water delivery!”" },
            { name: "Neha Patel", msg: "“Everything organized & easy now.”" },
            { name: "Vivek Yadav", msg: "“Great for delivery & admin sync.”" },
          ].map((t, i) => (
            <div
              key={i}
              style={{
                background: "#fff",
                color: "#022c32",
                padding: 20,
                borderRadius: 10,
                maxWidth: 300,
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              }}
            >
              <p style={{ fontStyle: "italic" }}>{t.msg}</p>
              <strong>— {t.name}</strong>
            </div>
          ))}
        </div>
      </section>

      {/* 🔹 Contact */}
      <section style={{ background: "#fff", padding: "50px 20px", textAlign: "center" }}>
        <h2 style={{ color: "#022c32" }}>Book Our Services</h2>
        <p style={{ color: "#555", marginBottom: 20 }}>
          Looking for premium water delivery services?
        </p>

        <button
          onClick={() => {
            const a = document.createElement("a");
            a.href = "tel:+919926202603";
            a.click();
          }}
          style={{
            background: "linear-gradient(120deg, #03b8b3, #04d4cd)",
            color: "#fff",
            border: "none",
            borderRadius: 10,
            padding: "12px 25px",
            fontSize: "1rem",
            fontWeight: 600,
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <FaPhoneAlt /> Contact Us Now
        </button>
      </section>
    </>
  );
}